'use client';

import { Box, Container, Step, StepIconProps, StepLabel, Stepper, Typography } from '@mui/material';
import Image from 'next/image';

import GlobalBlockRenderer from '@/components/ContentBlocks/GlobalBlockRenderer/GlobalBlockRenderer';
import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { ComponentBlocksTimeline } from '@/types';

interface TimelineProps {
  timeline: ComponentBlocksTimeline[];
}

function StepIcon(props: StepIconProps) {
  const { className } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        marginLeft: { xs: '-0.9rem', sm: '-0.625rem' },
        img: {
          marginTop: '0.465rem',
          width: { xs: '75px', sm: '107px' },
          height: { xs: '79px', sm: '112px' },
        },
      }}
      zIndex={20}
      className={className}
    >
      <Image src="/assets/icon-flag.png" width={107} height={112} alt="Flag" />
    </Box>
  );
}

export default function Timeline(props: TimelineProps) {
  return (
    <>
      <CustomBackground
        backgroundOptions={{
          BackgroundColor: 'purple-800',
          BackgroundOrbs: 'secondary-1-top',
        }}
        displayOptions={{
          PaddingTop: 'none',
          PaddingBottom: 'md',
          PaddingInline: 'sm',
        }}
      >
        <Container maxWidth="sm">
          <Stepper
            alternativeLabel
            activeStep={props.timeline.length}
            orientation="vertical"
            sx={(theme) => ({
              position: 'relative',
              '.MuiStepConnector-line': {
                display: 'none',
              },
              '&:before': {
                content: '""',
                display: 'block',
                background: `linear-gradient(180deg, ${theme.palette.brand.secondary} 0.88%, ${theme.palette.brand.secondary1} 99.4%)`,
                position: 'absolute',
                left: { xs: 'calc(7.5% - 0.35rem)', sm: '2.5rem' },
                width: { xs: '0.25rem', sm: '0.5rem' },
                top: { xs: '4rem', sm: '6.5rem' },
                bottom: '-3rem',
              },
            })}
          >
            {props.timeline.map((step) => (
              <Step key={step.Year}>
                <StepLabel
                  StepIconComponent={StepIcon}
                  sx={{
                    display: 'grid',
                    alignItems: 'start',
                    gridTemplateColumns: { xs: '15% 1fr', sm: '8rem 1fr' },
                    gap: 2,
                    columnGap: 4,
                    '.MuiStepLabel-label': {
                      textAlign: 'left',
                    },
                  }}
                >
                  <Box sx={(theme) => ({ color: theme.palette.purple[200] })}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <Typography
                        fontSize={24}
                        sx={(theme) => ({
                          color: theme.palette.brand.secondary,
                        })}
                      >
                        {step.Year}
                      </Typography>
                      <Typography
                        fontSize={24}
                        sx={(theme) => ({ color: theme.palette.common.white })}
                      >
                        {step.Title}
                      </Typography>
                    </Box>
                    <GlobalBlockRenderer content={step.Body || []} />
                  </Box>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Container>
      </CustomBackground>
    </>
  );
}
